import React, { useEffect, useMemo, useState } from "react";
import { get, post } from "../../services/api";
import { MaterialReactTable } from "material-react-table";
import { Button, Box } from "@mui/material";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useNavigate } from "react-router-dom";
import FullScreenLoader from "../../components/FullScreenLoader";
import InspAdmissionChallanModal from "./InspAdmissionChallanModal";
import AssignRollNoModal from "./AssignRollNoModal";
import IISSLogo from "../../assets/img/logo-full.png";
import AssessmentMarksModal from "../register/AssessmentMarksModal";
import PayRegChallanModal from "../register/PayRegChallanModal";
import CreateStudentModal from "../register/CreateStudentModal";
import PayAdmissionChallanModal from "../register/PayAdmissionChallanModal";
import RegPaymentProofModal from "../../components/modals/RegPaymentProofModal";
import ImportStudentDataModal from "./ImportStudentDataModal";

function Approval() {
  const token = localStorage.getItem("token");
  const centerId = localStorage.getItem("centerId");
  const organizationId = localStorage.getItem("organizationId");
  const userId = localStorage.getItem("userId");
  const roleId = localStorage.getItem("roleId"); // Added roleId for permission logic
  const navigate = useNavigate();

  const [studentsData, setStudentsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [columnLabels, setColumnLabels] = useState({
    studentFullName: "Student Full Name",
    dob: "Date of Birth",
    genderName: "Gender",
    centerName: "Center Name",
    className: "Class Name",
    sessionName: "Session Name",
    entryTermName: "Entry Term Name",
    code: "Code",
  });
  const [showChallanModal, setShowChallanModal] = useState(false);
  const [showAssignRollNoModal, setShowAssignRollNoModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isAssessmentMarksModalVisible, setIsAssessmentMarksModalVisible] =
    useState(false);
  const [showPayRegModal, setShowPayRegModal] = useState(false);
  const [payRegModalData, setPayRegModalData] = useState(null);
  const [showPayAdmissionModal, setShowPayAdmissionModal] = useState(false);
  const [payAdmissionModalData, setPayAdmissionModalData] = useState(null);
  const [isCreateStudentModalVisible, setIsCreateStudentModalVisible] =
    useState(null);
  const [regPaymentProofModalData, setRegPaymentProofModalData] =
    useState(null);
  const [paymentProofType, setPaymentProofType] = useState("");
  const [showRegPaymentProofModal, setShowRegPaymentProofModal] =
    useState(false);
  const [showImportModal, setShowImportModal] = useState(false);

  const columnsToHide = [
    "id",
    "applyingForSession",
    "classId",
    "entryTermId",
    "genderId",
    "languageId",
    "centerId",
    "isDelete",
    "createdOn",
    "createdBy",
    "updatedOn",
    "updatedBy",
    "registrationStatusDto",
  ];

  // Centralized role-based button permissions
  const rolePermissions = {
    10: [
      "registrationChallan",
      "registrationPaymentProof",
      "viewRegistrationPaymentProof",
      "admissionChallan",
      "admissionPaymentProof",
      "viewAdmissionPaymentProof",
      "createStudent",
    ],
    default: [
      "registrationChallan",
      "registrationPaymentProof",
      "viewRegistrationPaymentProof",
      "payRegistrationChallan",
      "assessmentMarks",
      "admissionChallan",
      "admissionPaymentProof",
      "viewAdmissionPaymentProof",
      "payAdmissionChallan",
      "createStudent",
    ],
  };

  // Button definitions with conditions and JSX
  const buttonDefinitions = [
    {
      key: "registrationChallan",
       condition: (status) =>
        status.isRegistrationFeeZero,
      element: (row, status) => (
        <button
          type="button"
          className="btn p-1"
          data-tooltip-id="global-tooltip"
          data-tooltip-content="Registration Challan"
          onClick={(e) => {
            e.stopPropagation();
            handlePrintChallan(row.original, "Registration Fee");
          }}
        >
          <i className="text-primary fs-8 fas fa-print"></i>
        </button>
      ),
    },
    {
      key: "registrationPaymentProof",
      condition: (status) =>
        status.isRegistrationChallanGenerated && !status.isRegistrationFeePaid,
      element: (row, status) => (
        <button
          type="button"
          className="btn p-1"
          data-tooltip-id="global-tooltip"
          data-tooltip-content="Registration Payment Proof"
          onClick={(e) => {
            e.stopPropagation();
            handleAttachmentFileChange(row.original.id);
          }}
        >
          <i className="text-primary fs-8 fas fa-paperclip"></i>
        </button>
      ),
    },
    {
      key: "viewRegistrationPaymentProof",
      condition: (status) =>
        status.isRegistrationPaymentProofAttached &&
        !status.isRegistrationFeePaid,
      element: (row, status) => (
        <button
          type="button"
          className="btn p-1"
          data-tooltip-id="global-tooltip"
          data-tooltip-content="View Registration Payment Proof"
          onClick={(e) => {
            e.stopPropagation();
            handleViewRegReceiptChallan(row.original.id);
          }}
        >
          <i className="text-primary fs-8 fas fa-receipt"></i>
        </button>
      ),
    },
    {
      key: "payRegistrationChallan",
      condition: (status) =>
        status.isRegistrationPaymentProofAttached &&
        !status.isRegistrationFeePaid,
      element: (row, status) => (
        <button
          type="button"
          className="btn p-1"
          data-tooltip-id="global-tooltip"
          data-tooltip-content="Pay Registration Challan"
          onClick={(e) => {
            e.stopPropagation();
            handlePayRegChallanClick(row.original);
          }}
        >
          <i className="text-primary fs-8 fas fa-file-invoice"></i>
        </button>
      ),
    },
    {
      key: "assessmentMarks",
      condition: (status) =>
        status.isRegistrationFeePaid && !status.isAssessmentAdded,
      element: (row, status) => (
        <button
          type="button"
          className="btn p-1"
          data-tooltip-id="global-tooltip"
          data-tooltip-content="Assessment Marks"
          onClick={(e) => {
            e.stopPropagation();
            openAssessmentMarksModal(row.original);
          }}
        >
          <i className="text-primary fs-8 fas fa-calendar-days"></i>
        </button>
      ),
    },
    {
      key: "admissionChallan",
      condition: (status) => status.isAssessmentAdded,
      element: (row, status) => (
        <button
          type="button"
          className="btn p-1"
          data-tooltip-id="global-tooltip"
          data-tooltip-content="Admission Challan"
          onClick={(e) => {
            e.stopPropagation();
            handlePrintChallan(row.original, "Admission Fee");
          }}
        >
          <i className="text-primary fs-8 fas fa-print"></i>
        </button>
      ),
    },
    {
      key: "admissionPaymentProof",
      condition: (status) =>
        status.isAdmissionChallanGenerated && !status.isAdmissionFeePaid,
      element: (row, status) => (
        <button
          type="button"
          className="btn p-1"
          data-tooltip-id="global-tooltip"
          data-tooltip-content="Admission Payment Proof"
          onClick={(e) => {
            e.stopPropagation();
            handleAttachmentAdmissionFileChangeA(row.original.id);
          }}
        >
          <i className="text-primary fs-8 fas fa-paperclip"></i>
        </button>
      ),
    },
    {
      key: "viewAdmissionPaymentProof",
      condition: (status) =>
        status.isAdmissionPaymentProofAttached && !status.isAdmissionFeePaid,
      element: (row, status) => (
        <button
          type="button"
          className="btn p-1"
          data-tooltip-id="global-tooltip"
          data-tooltip-content="View Admission Payment Proof"
          onClick={(e) => {
            e.stopPropagation();
            handleViewAdmissionReceiptChallan(row.original.id);
          }}
        >
          <i className="text-primary fs-8 fas fa-receipt"></i>
        </button>
      ),
    },
    {
      key: "payAdmissionChallan",
      condition: (status) =>
        status.isAdmissionPaymentProofAttached && !status.isAdmissionFeePaid,
      element: (row, status) => (
        <button
          type="button"
          className="btn p-1"
          data-tooltip-id="global-tooltip"
          data-tooltip-content="Pay Admission Challan"
          onClick={(e) => {
            e.stopPropagation();
            handlePayAdmissionChallanClick(row.original);
          }}
        >
          <i className="text-primary fs-8 fas fa-file-invoice"></i>
        </button>
      ),
    },
    {
      key: "createStudent",
      condition: (status) =>
        roleId === "10" ? status.isStudentCreated : status.isAdmissionFeePaid,
      element: (row, status) => (
        <button
          type="button"
          className="btn custom-disabled-btn p-1 border-0"
          data-tooltip-id="global-tooltip"
          data-tooltip-content={
            status.isStudentCreated ? "Student Created" : "Create Student"
          }
          onClick={(e) => {
            e.stopPropagation();
            openCreateStudentModal(row.original);
          }}
          disabled={status.isStudentCreated}
        >
          <i
            className={`text-primary fs-8 fas ${
              status.isStudentCreated ? "fa-user-check" : "fa-user-plus"
            }`}
          ></i>
        </button>
      ),
    },
  ];

  const fetchStudents = async () => {
    setLoading(true);
    try {
      if (!centerId || !organizationId) {
        throw new Error("Center ID and Organization ID are required");
      }

      const centerIdNum = parseInt(centerId);
      const organizationIdNum = parseInt(organizationId);

      if (isNaN(centerIdNum) || centerIdNum <= 0) {
        throw new Error("Invalid Center ID");
      }

      if (isNaN(organizationIdNum) || organizationIdNum <= 0) {
        throw new Error("Invalid Organization ID");
      }

      let userIdToPass = roleId == "10" ? userId : "";

      const response = await get(
        `InspStudentFirstRegistrtion/listByCenter?organizationId=${organizationIdNum}&centerId=${centerIdNum}&userId=${userIdToPass}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Check if response is an array (based on provided API response)
      if (!Array.isArray(response)) {
        throw new Error(
          "Unexpected response format: Expected an array of students"
        );
      }

      const processedData = response.map((student) => ({
        ...student,
        createdBy: userId,
        parentCnic:
          student.cnic || student.parentCnic || student.familyInfo?.cnic, // adjust path
        dob: student.dob
          ? new Date(student.dob).toISOString().split("T")[0]
          : "",
        updatedBy: userId,
        dob: student.dob
          ? new Date(student.dob).toISOString().split("T")[0]
          : "",
        registrationStatusDto: student.registrationStatusDto || {
          isRegistrationFeePaid: false,
          isAdmissionFeePaid: false,
          isRegistrationChallanGenerated: false,
          isAdmissionChallanGenerated: false,
          isAssessmentAdded: false,
          isStudentCreated: false,
          isRegistrationPaymentProofAttached: false,
          isAdmissionPaymentProofAttached: false,
        },
      }));

      setStudentsData(processedData);
    } catch (error) {
      console.error("Error fetching students:", error);
      toast.error(`Failed to fetch student data: ${error.message}`);
      setStudentsData([]);
    } finally {
      setLoading(false);
    }
  };

  // Base64-encoded placeholder image (grey square) as a fallback
  const placeholderLogo =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAIAAAD/gAIDAAAACXBIWXMAAAsTAAALEwEAmpwYAAABJklEQVR4nO3TsQ3AMAwAwfxf6WADYgMLcQAFa4AJa4AJ0zM+7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv7DwAALB0i1O1VHrUAAAAASUVORK5CYII=";

  const handlePrintChallan = async (
    student,
    challanType = "Registration Fee"
  ) => {
    try {
      setLoading(true);

      if (!student) {
        throw new Error("Student not found");
      }

      // Fetch fee plans (only API used)
      const feePlanResponse = await get(
        challanType === "Registration Fee"
          ? `Student/GenerateInvoice?FirstRegistrationId=${student.id}&createdBy=${userId}&centerSessionId=${student.applyingForSession}`
          : `Student/GenerateAdmissionChallan?FirstRegistrationId=${student.id}&createdBy=${userId}&centerSessionId=${student.applyingForSession}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!feePlanResponse.isSuccess || !feePlanResponse.centerFeePlans) {
        throw new Error(feePlanResponse.message || "Failed to fetch fee plans");
      }

      // Filter fee items based on challan type
      const feeItems = feePlanResponse.centerFeePlans.filter((plan) =>
        challanType === "Registration Fee"
          ? plan.feeTypeName === "Registration Fee"
          : plan.feeTypeName !== "Registration Fee"
      );

      if (feeItems.length === 0) {
        throw new Error("No applicable fees found for this student");
      }

      // Calculate total amount
      const totalAmount = feeItems.reduce((sum, item) => sum + item.amount, 0);

      // Format issueDate and dueDate from API response
      const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
      };

      const issueDate = formatDate(feeItems[0].issueDate); // From API
      const dueDate = formatDate(feeItems[0].dueDate); // From API

      // Prepare data for the challan
      const challanData = {
        items: feeItems.map((item) => ({
          headName: item.feeTypeName,
          headCode: item.code || "N/A",
          amount: item.amount,
          periodDesc: `${item.feeCycleName || "N/A"} (${
            item.feePlanName || "N/A"
          })`,
          waiveOfAmount: 0,
          challanNo: item.challanNo,
          centerName: item.centerName,
          studentName: student.studentFullName,
          firstRegistrationId: student.id,
          className: item.className || student.className || "N/A",
          challanDate: issueDate,
          dueDate: dueDate,
          totalAmount,
          nwaAccountNo: "1234567890",
          branchCode: "0001",
          branchName: "Main Branch",
          isPaid: false,
          baseUrl: "",
        })),
      };

      // Custom Voucher Logic for Center 2076
      if (centerId === "2076") {
        const commonData = {
          acNo: feeItems[0]?.code || challanData.items[0].nwaAccountNo,
          className: challanData.items[0].className,
          feeMonth: feeItems.find(i => i.feeTypeName.toLowerCase().includes("admission"))?.feeTypeName || feeItems[0]?.feeTypeName || issueDate,
          studentName: student.studentFullName,
          fatherName: feeItems[0]?.fatherName || student.fatherName || "",
          contact: "0345-7586677",
          dueDate: dueDate,
          totalDue: totalAmount.toFixed(0),
          totalAfter: (totalAmount + 100).toFixed(0),
          admissionFee: feeItems.find(i => i.feeTypeName.toLowerCase().includes("admission"))?.amount.toFixed(0) || "0",
          tutionFee: feeItems.find(i => i.feeTypeName.toLowerCase().includes("tution") || i.feeTypeName.toLowerCase().includes("tuition"))?.amount.toFixed(0) || "0",
          regFee: feeItems.find(i => i.feeTypeName.toLowerCase().includes("registration"))?.amount.toFixed(0) || "0",
          balance: "0",
          annualStationery: feeItems.find(i => i.feeTypeName.toLowerCase().includes("annual"))?.amount.toFixed(0) || "0",
          acCharges: feeItems.find(i => i.feeTypeName.toLowerCase().includes("ac charges"))?.amount.toFixed(0) || "0",
          sportsFee: feeItems.find(i => i.feeTypeName.toLowerCase().includes("sports"))?.amount.toFixed(0) || "0",
          others: feeItems.filter(i => !["admission", "tution", "tuition", "registration", "ac charges", "sports", "annual"].some(t => i.feeTypeName.toLowerCase().includes(t)))
                           .reduce((sum, i) => sum + i.amount, 0).toFixed(0),
          stationery: "0",
          fine: "0",
          paperFund: "0",
          transportFee: "0",
          other: "0",
          admissionVoucher: challanData.items[0].challanNo,
          centerImagePath: feeItems[0]?.centerImagePath ? `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages${feeItems[0].centerImagePath}` : "",
        };

        // Store data in localStorage for the voucher page to read
        localStorage.setItem('customVoucherData', JSON.stringify(commonData));

        if (challanType === "Registration Fee") {
          window.open('/registration-challan', '_blank');
        } else {
          window.open('/admission-voucher', '_blank');
        }
        setLoading(false);
        return;
      }

      // Generate PDF
      const doc = new jsPDF({
        orientation: "landscape",
        unit: "pt",
        format: "a4",
      });

      // Define styles
      const styles = {
        font: "helvetica",
        fontSize: 9.5,
        cellPadding: 2,
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
      };

      // Define copies
      const copies = ["Bank Copy", "School Copy", "Student Copy"];
      let currentX = 20;

      // Load logo image
      let logoImage = placeholderLogo;
      try {
        const response = await fetch(IISSLogo);
        if (response.ok) {
          const blob = await response.blob();
          logoImage = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
          });
        } else {
          console.warn("Failed to fetch logo, using placeholder");
        }
      } catch (error) {
        console.warn("Error loading logo, using placeholder:", error);
      }

      copies.forEach((copy) => {
        // Header (Logo and Copy Name)
        doc.addImage(logoImage, "PNG", currentX, 20, 100, 40);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8.5);
        doc.text(`${copy}`, currentX + 110, 40, { align: "left" });

        // Challan number
        doc.autoTable({
          startY: 80,
          body: [
            [
              {
                content: `Challan #: ${challanData.items[0].challanNo}`,
                styles: { halign: "center" },
              },
            ],
          ],
          styles,
          margin: { left: currentX },
          tableWidth: 260,
        });

        // School and student info
        doc.autoTable({
          startY: doc.lastAutoTable.finalY + 10,
          body: [
            [
              {
                content: `Center/Campus: ${challanData.items[0].centerName}`,
                styles: { fontStyle: "bold" },
              },
            ],
            [
              {
                content: `Student Name: ${challanData.items[0].studentName}`,
                styles: { fontStyle: "bold" },
              },
            ],
            [
              {
                content: `Class: ${challanData.items[0].className}`,
                styles: { fontStyle: "bold" },
              },
            ],
            [
              {
                content: `Issue Date: ${challanData.items[0].challanDate}`,
                styles: { fontStyle: "bold" },
              },
            ],
            [
              {
                content: `Due Date: ${challanData.items[0].dueDate}`,
                styles: { fontStyle: "bold" },
              },
            ],
            [
              {
                content:
                  challanType === "Registration Fee"
                    ? "REGISTRATION CHALLAN"
                    : "ADMISSION CHALLAN",
                styles: { halign: "center", fontStyle: "bold", fontSize: 11.5 },
              },
            ],
          ],
          styles: { ...styles, border: 0 },
          margin: { left: currentX },
          tableWidth: 260,
        });

        // Fee items table
        doc.autoTable({
          startY: doc.lastAutoTable.finalY + 10,
          head: [["Description", "Amount"]],
          body: challanData.items.map((item) => [
            `${item.headName}\n${item.periodDesc}`,
            {
              content: `${item.amount.toFixed(2)}`,
              styles: { halign: "right" },
            },
          ]),
          styles,
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            fontStyle: "bold",
          },
          columnStyles: {
            0: { cellWidth: 180, fontStyle: "normal", fontSize: 8 },
            1: { cellWidth: 80, halign: "right" },
          },
          margin: { left: currentX },
          tableWidth: 260,
        });

        // Total table
        doc.autoTable({
          startY: doc.lastAutoTable.finalY + 5,
          body: [
            [
              { content: "Total", styles: { fontStyle: "bold" } },
              {
                content: `${totalAmount.toFixed(2)}`,
                styles: { halign: "right" },
              },
            ],
            [
              { content: "Paid / Adjusted", styles: { fontStyle: "normal" } },
              { content: "", styles: { halign: "right" } },
            ],
            [
              {
                content: "Total Payment By Due Date",
                styles: { fontStyle: "bold" },
              },
              {
                content: `${totalAmount.toFixed(2)}`,
                styles: { halign: "right", fontStyle: "bold" },
              },
            ],
          ],
          styles: { ...styles, border: 0 },
          margin: { left: currentX },
          tableWidth: 260,
        });

        // Bank details table
        doc.autoTable({
          startY: doc.lastAutoTable.finalY + 30,
          body: [
            ["Account # Collection:", challanData.items[0].nwaAccountNo],
            ["Branch Code:", challanData.items[0].branchCode],
            ["Account Title:", `${challanData.items[0].centerName}`],
            ["Branch Name:", challanData.items[0].branchName],
            ["Challan No.:", challanData.items[0].challanNo],
            ["Due Date:", challanData.items[0].dueDate],
          ],
          styles: { ...styles, fontSize: 7.5, border: 1 },
          margin: { left: currentX },
          tableWidth: 260,
        });

        // Footer table
        doc.autoTable({
          startY: doc.lastAutoTable.finalY + 10,
          body: [
            [
              {
                content: "CASH ONLY\nBank Stamp Here",
                styles: {
                  halign: "center",
                  fontSize: 17.5,
                  fontStyle: "bold",
                  textColor: [225, 225, 225],
                },
              },
            ],
          ],
          styles: { ...styles, border: 0 },
          margin: { left: currentX },
          tableWidth: 260,
        });

        // System generated note
        doc.autoTable({
          startY: doc.lastAutoTable.finalY + 10,
          body: [
            ["This is a system-generated document and needs no signature"],
          ],
          styles: { ...styles, fontSize: 7, border: 0 },
          margin: { left: currentX },
          tableWidth: 260,
        });

        currentX += 270; // Move to next column
      });

      // Save PDF and open in new tab
      const pdfBlob = doc.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const newWindow = window.open(pdfUrl, "_blank");
      if (!newWindow) {
        console.warn("Pop-up blocked. Please allow pop-ups to view the PDF.");
        toast.error("Pop-up blocked. Please allow pop-ups to view the PDF.");
      }
      setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000); // Clean up URL

      await fetchStudents?.(); // Optional refresh
    } catch (error) {
      console.error("Error generating challan:", error);
      toast.error(
        `Failed to generate ${challanType} challan: ${error.message}`
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await fetchStudents();
      setLoading(false);
    };

    fetchData();
  }, []);

  const handleGenerateChallan = (student) => {
    setSelectedStudent(student);
    setShowChallanModal(true);
  };

  const columns = useMemo(() => {
    return [
      ...Object.keys(columnLabels).map((key) => ({
        accessorKey: key,
        id: key,
        header: columnLabels[key],
        filterVariant: key.includes("is") ? "checkbox" : "text",
        enableColumnFilter: true,
        enableColumnFilterModes: true,
        filterModeOptions: [
          "contains",
          "startsWith",
          "endsWith",
          "equals",
          "notEquals",
          "greaterThan",
          "lessThan",
          "greaterThanOrEqualTo",
          "lessThanOrEqualTo",
          "between",
          "empty",
          "notEmpty",
        ],
        filterFn:
          key.includes("Id") || key.includes("No") || key.startsWith("is")
            ? "equals"
            : key.includes("Date") || key.includes("On") || key.includes("dob")
            ? "between"
            : "contains",
        enableSorting: true,
        size: 200,
        minSize: 50,
        maxSize: 1000,
      })),
      {
        accessorKey: "actions",
        id: "actions",
        header: "Actions",
        enableColumnFilter: false,
        enableSorting: false,
        enableHiding: false,
        enableResizing: false,
        enablePinning: true,
        pinned: "right",
        size: 250,
        Cell: ({ row }) => {
          const status = row.original.registrationStatusDto || {};
          
          if (row.original.isDataImported === true) {
            return <div className="d-flex align-items-center gap-1"></div>;
          }

          const allowedButtons =
            rolePermissions[roleId] || rolePermissions.default;

          return (
            <div className="d-flex align-items-center gap-1">
              {buttonDefinitions
                .filter(
                  (button) =>
                    allowedButtons.includes(button.key) &&
                    button.condition(status)
                )
                .map((button) => (
                  <React.Fragment key={button.key}>
                    {button.element(row, status)}
                  </React.Fragment>
                ))}
            </div>
          );
        },
      },
    ];
  }, [columnLabels, roleId]);

  const exportToExcel = () => {
    if (studentsData.length === 0) {
      toast.warning("No data to export");
      return;
    }

    const exportData = studentsData.map((student) => {
      const exportStudent = {};
      Object.keys(student).forEach((key) => {
        if (!columnsToHide.includes(key) && key !== "isDelete") {
          exportStudent[key] = student[key];
        }
      });
      return exportStudent;
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Student Registrations");
    XLSX.writeFile(workbook, "student_registrations.xlsx");
  };

  const exportToPDF = () => {
    if (studentsData.length === 0) {
      toast.warning("No data to export");
      return;
    }

    const doc = new jsPDF("landscape");
    const pageWidth = doc.internal.pageSize.getWidth();
    // const logoWidth = 30;
    // const logoHeight = 8;
    // const logoX = (pageWidth - logoWidth) / 2;
    // const logoY = 10;
    // doc.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);

    const title = "Pending Students Data";
    const titleFontSize = 12;
    doc.setFontSize(titleFontSize);
    doc.setFont("helvetica", "bold");
    const textWidth = doc.getTextWidth(title);
    const titleX = (pageWidth - textWidth) / 2;
    const titleY = 20;
    doc.text(title, titleX, titleY);

    const columns = Object.keys(columnLabels).map((key) => ({
      header: columnLabels[key],
      dataKey: key,
    }));

    const headers = [columns.map((col) => col.header)];

    const bodyData = studentsData.map((row) =>
      columns.map((col) => row[col.dataKey] ?? "")
    );

    doc.autoTable({
      head: headers,
      body: bodyData,
      theme: "striped",
      startY: titleY + 10,
      headStyles: {
        fillColor: [132, 23, 26],
        textColor: [255, 255, 255],
        halign: "center",
      },
      styles: {
        // fontSize: 8,
        // cellPadding: 4,
        overflow: "linebreak",
        // minCellHeight: 20,
      },
    });

    doc.save("pending_students_data.pdf");
  };

  const handlePayRegChallanClick = async (row) => {
    try {
      const response = await get(
        `AssessmentType/GetRegistartionVoucherByRegIdAsync?studentFirstRegistrationId=${row.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.isSuccess) {
        setPayRegModalData(response?.registrationVoucher);
        setShowPayRegModal(true);
      } else {
        console.error("Error fetching fee details");
      }
    } catch (error) {
      console.error("Error fetching registration voucher:", error);
    }
  };

  const submitPayRegChallan = async (formData) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }
    const currentDate = new Date().toISOString();
    const formDataWithPaymentInfo = {
      ...formData,
      createdBy: localStorage.getItem("userId"),
      updatedBy: localStorage.getItem("userId"),
      paidBy: localStorage.getItem("userId"),
      isPaid: true,
      paymentDate: currentDate,
      id: formData.id,
      voucherNo: formData.voucherNo,
    };

    try {
      const response = await post(
        `AssessmentType/UpdateRegistartionVoucherPaidAsync`,
        formDataWithPaymentInfo,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setShowPayRegModal(false);
        await fetchStudents(); // Refresh data to update registrationStatusDto
      }
    } catch (error) {
      console.error("Error saving category:", error);
    }
  };

  const openAssessmentMarksModal = (row) => {
    setSelectedRow(row);
    setIsAssessmentMarksModalVisible(true);
  };

  const handlePayAdmissionChallanClick = async (row) => {
    try {
      const queryString = `studentFirstRegistrationId=${row.id}&createdBy=${userId}`; 
      const response = await get(
        `AssessmentType/GetAdmissionVoucherByRegistartionNoAsync?${queryString}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.isSuccess) {
        setPayAdmissionModalData(response?.admissionVoucher[0]);
        setShowPayAdmissionModal(true);
      } else {
        console.error("Error fetching fee details");
      }
    } catch (error) {
      console.error("Error fetching admission voucher:", error);
    }
  };

  const submitPayAdmissionChallan = async (formData) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }
    const currentDate = new Date().toISOString();
    const formDataWithPaymentInfo = {
      ...formData,
      createdBy: localStorage.getItem("userId"),
      updatedBy: localStorage.getItem("userId"),
      paidBy: localStorage.getItem("userId"),
      isPaid: true,
      paymentDate: currentDate,
      id: formData.id,
      voucherNo: formData.voucherNo,
    };

    try {
      const response = await post(
        `AssessmentType/UpdateAdmissionVoucherPaidAsync`,
        formDataWithPaymentInfo,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setShowPayAdmissionModal(false);
        await fetchStudents(); // Refresh data to update registrationStatusDto
      }
    } catch (error) {
      console.error("Error saving category:", error);
    }
  };

  const openCreateStudentModal = (row) => {
    setSelectedRow(row);
    setIsCreateStudentModalVisible(true);
  };

  const handleAttachmentFileChange = async (index) => {
    setRegPaymentProofModalData({ id: index });
    setPaymentProofType("registration");
    setShowRegPaymentProofModal(true);
  };

  const handleAttachmentAdmissionFileChangeA = async (index) => {
    setRegPaymentProofModalData({ id: index });
    setPaymentProofType("admission");
    setShowRegPaymentProofModal(true);
  };

  const handleViewRegReceiptChallan = async (firstRegistrationId) => {
    if (!firstRegistrationId) {
      alert("Error");
      return;
    }
    setLoading(true);
    const API_BASE_URL = process.env.REACT_APP_API_URL;
    try {
      const response = await fetch(
        `${API_BASE_URL}Student/ViewRegReceiptChallan?FirstRegistrationId=${firstRegistrationId}`,
        { method: "GET", headers: { Authorization: `Bearer ${token}` } }
      );
      if (!response.ok) throw new Error("Network response was not ok");
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      window.open(url);
      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    } catch (error) {
      console.error("Error opening the invoice:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleRegPaymentProofSubmit = async (formData) => {
    setLoading(true);
    try {
      const endpoint =
        paymentProofType === "registration"
          ? "Student/AddStudentRegistrationChallanReceipt"
          : "Student/AddStudentAdmissionChallanReceipt";

      const payload = {
        ReceiptName: formData.receiptName,
        Base64Url: formData.base64Url,
        StudentFirstRegistrationId: formData.studentFirstRegistrationId,
        createdBy: localStorage.getItem("userId"),
      };

      const response = await post(endpoint, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setShowRegPaymentProofModal(false);
        await fetchStudents(); // Refresh data to update registrationStatusDto
      } else {
        toast.error(response.message || "An unexpected error occurred");
      }
    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Failed to upload payment proof");
    } finally {
      setLoading(false);
    }
  };

  const handleViewAdmissionReceiptChallan = async (firstRegistrationId) => {
    if (!firstRegistrationId) {
      alert("Error");
      return;
    }
    setLoading(true);
    const API_BASE_URL = process.env.REACT_APP_API_URL;
    try {
      const response = await fetch(
        `${API_BASE_URL}Student/ViewAdmReceiptChallan?FirstRegistrationId=${firstRegistrationId}`,
        { method: "GET", headers: { Authorization: `Bearer ${token}` } }
      );
      if (!response.ok) throw new Error("Network response was not ok");
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      window.open(url);
      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    } catch (error) {
      console.error("Error opening the invoice:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-3">
        <h2 className="page-heading fs-7">Student Registrations</h2>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="custom-mrt-table-wrapper">
            {loading ? (
              <div className="text-center p-4">Loading...</div>
            ) : columns.length > 0 ? (
              <MaterialReactTable
                columns={columns}
                data={studentsData}
                enableColumnFilters
                enableGlobalFilter
                enableColumnDragging
                enableColumnResizing
                enableHiding
                enableColumnOrdering
                enableSorting
                enableStickyHeader
                enableColumnFilterModes
                defaultColumn={{
                  minSize: 50,
                  maxSize: 1000,
                  size: 200,
                }}
                initialState={{
                  showColumnFilters: true,
                  columnOrder: [...Object.keys(columnLabels), "actions"],
                  density: "compact",
                  columnPinning: { right: ["actions"] },
                }}
                muiTableBodyRowProps={({ row }) => ({
                  onClick: () => {
                    const student = row.original;
                    // Find parent's CNIC from registrationStatusDto or family info (adjust key if needed)
                    const parentCnic =
                      student.cnic || student.parentCnic || student.familyCnic;

                    if (parentCnic) {
                      // Navigate to Inquiry page with CNIC pre-filled
                      navigate(
                        `/student-inquiry?cnic=${encodeURIComponent(
                          parentCnic
                        )}`
                      );
                    } else {
                      toast.warning("Parent CNIC not found for this student.");
                    }
                  },
                  sx: {
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "#f5f5f5",
                    },
                  },
                })}
                muiTableProps={{
                  className: "custom-mrt-table",
                }}
                muiTableHeadCellProps={{
                  className: "custom-mrt-table-head-cell",
                }}
                muiTableBodyCellProps={{
                  className: "custom-mrt-table-body-cell",
                }}
                renderTopToolbarCustomActions={() => (
                  <div className="d-flex gap-1 align-items-center">
                    <button
                      type="button"
                      className="btn btn-with-icon-and-tooltip"
                      data-tooltip-id="global-tooltip"
                      data-tooltip-content="Import Data"
                      onClick={() => setShowImportModal(true)}
                    >
                      <i className="text-primary fs-7 fas fa-file-import"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-with-icon-and-tooltip"
                      data-tooltip-id="global-tooltip"
                      data-tooltip-content="Export to Excel"
                      onClick={exportToExcel}
                    >
                      <i className="text-success fs-7 fas fa-file-excel"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-with-icon-and-tooltip"
                      data-tooltip-id="global-tooltip"
                      data-tooltip-content="Export to PDF"
                      onClick={exportToPDF}
                    >
                      <i className="text-danger fs-7 fas fa-file-pdf"></i>
                    </button>
                  </div>
                )}
              />
            ) : (
              <div className="text-center p-4">
                 Loading columns...
              </div>
            )}
          </div>
        </div>
      </div>

      {loading && <FullScreenLoader />}

      {showChallanModal && (
        <InspAdmissionChallanModal
          open={showChallanModal}
          onClose={() => setShowChallanModal(false)}
          student={selectedStudent}
        />
      )}

      {showAssignRollNoModal && (
        <AssignRollNoModal
          open={showAssignRollNoModal}
          onClose={() => setShowAssignRollNoModal(false)}
          student={selectedStudent}
        />
      )}

      {showPayRegModal && (
        <PayRegChallanModal
          title="Pay Registration Challan"
          onClose={() => setShowPayRegModal(false)}
          regModalData={payRegModalData}
          payRegChallan={submitPayRegChallan}
        />
      )}

      {isAssessmentMarksModalVisible && (
        <AssessmentMarksModal
          centerId={centerId}
          classId={selectedRow?.classId}
          firstRegistrationId={selectedRow.id}
          onClose={() => setIsAssessmentMarksModalVisible(false)}
          refreshOnSubmitSuccess={fetchStudents}
        />
      )}

      {showPayAdmissionModal && (
        <PayAdmissionChallanModal
          title="Pay Admission Challan"
          onClose={() => setShowPayAdmissionModal(false)}
          admissionModalData={payAdmissionModalData}
          payAdmissionChallan={submitPayAdmissionChallan}
        />
      )}

      {isCreateStudentModalVisible && (
        <CreateStudentModal
          regModalData={selectedRow}
          onClose={() => setIsCreateStudentModalVisible(false)}
          refreshOnSubmitSuccess={fetchStudents}
        />
      )}

      {showRegPaymentProofModal && (
        <RegPaymentProofModal
          title={
            paymentProofType === "registration"
              ? "Registration Payment Proof"
              : "Admission Payment Proof"
          }
          onClose={() => setShowRegPaymentProofModal(false)}
          modalData={regPaymentProofModalData}
          submitData={handleRegPaymentProofSubmit}
        />
      )}

      {showImportModal && (
        <ImportStudentDataModal
          onClose={() => setShowImportModal(false)}
          onSuccess={() => {
            setShowImportModal(false);
            fetchStudents();
          }}
        />
      )}

    </>
  );
}

export default Approval;
